import React, {useContext} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {useTableData} from "../../../../misc/scroller/Table";
import {Opening} from "../../../../api/Openings";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {CountBadge} from "../../shopdrawing/openings/DoorElevationHelpers";

export function ScreenElevationHeader() {
    const editCtx = useContext(EditContext);
    const data = useTableData<Opening|QuoteOpening>(editCtx.tableName)

    const missingElev = data.filter(d => {
        if(d.screenElevation !== "" && !d.screenElevationFile) return true;
        return false;
    }).length;

    return (
        <div style={{display: "flex", width: "100%"}}>
            <div style={{flex: 1}}>Screen Elevation</div>
            <CountBadge count={missingElev} label="Missing attachments" />
        </div>
    )
}